import { AppState } from 'Store'

const getAll = (state: AppState) => state.registryBusinessAccess.rbidosAccess.list.entries
const getCurrentParams = (state: AppState) =>
	state.registryBusinessAccess.rbidosAccess.requestParams
const getTotal = (state: AppState) => state.registryBusinessAccess.rbidosAccess.list.total_entries
const getCurrentRequest = (state: AppState) =>
	state.registryBusinessAccess.rbidosAccess.currentRequest
const getNewAgent = (state: AppState) => state.registryBusinessAccess.rbidosAccess.newAgent
const getErrorPartnerNalogRegDate = (state: AppState) =>
	state.registryBusinessAccess.rbidosAccess.errorPartnerNalogRegDate

export const rbidosAccessSelector = {
	getAll,
	getCurrentParams,
	getTotal,
	getCurrentRequest,
	getNewAgent,
	getErrorPartnerNalogRegDate,
}
